import {Component, inject, Input} from '@angular/core';
import {UserAvatarComponent} from "../../library/user-avatar/user-avatar.component";
import {Router} from "@angular/router";

@Component({
    selector: 'user-avatar-email',
    imports: [
        UserAvatarComponent
    ],
    templateUrl: './user-avatar-email.component.html',
    styleUrl: './user-avatar-email.component.scss'
})
export class UserAvatarEmailComponent {
    private router = inject(Router);

    @Input() name: string;
    @Input() avatarUrl: string;
    @Input() email: string;
    @Input() employeeId?: string;

    async onClick() {
        if (this.employeeId) {
            await this.router.navigate([`/employee/${this.employeeId}`]);
        }
    }
}
